import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for Mission Card - slide from left with fade and rotation
 */
export const animateAboutMissionCard = (ref) => {
  if (ref.current) {
    const element = ref.current;
    const card = element.querySelector('[class*="section"]') || element;
    
    // Set initial state immediately to prevent flash
    if (card) {
      gsap.set(card, { opacity: 0, x: -100, rotation: 5 });
    }
    
    const timer = setTimeout(() => {
      if (card) {
        gsap.to(card, {
          opacity: 1,
          x: 0,
          rotation: 0,
          duration: 1.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: element,
            start: "top 80%",
            toggleActions: "play none none none",
          },
        });
        ScrollTrigger.refresh();
      }
    }, 100);
    
    return () => clearTimeout(timer);
  }
};

